import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import { ThemeContextProvider } from "./ThemeContext";
import { Box } from "@mui/material";
import MetricsCalculator from "./pages/metrics-calculator";
import NutriAi from "./pages/nutri-ai";
import BookAppointment from "./pages/book-appointment";
import PracticalGuide from "./pages/practical-guide-on-meal-plan";
import Students from "./pages/students";

function App() {
  return (
    <ThemeContextProvider>
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: (theme) => theme.palette.background.default,
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/metrics-calculator" element={<MetricsCalculator/>}/>
            <Route path="/nutri-ai" element={<NutriAi/>}/>
            <Route path="/book-appointment" element={<BookAppointment/>}/>
            <Route path="/practical-guide-on-meal-plan" element={<PracticalGuide/>}/>
            <Route path="/students" element={<Students/>}/>
          </Routes>
        </BrowserRouter>
      </Box>
     
    </ThemeContextProvider>
  );
}

export default App;
